import classNames from 'classnames'

import { toCSSPixel } from '../../../../utils/styles'

import * as styles from './TableCellBase.module.css'

function TableCellBase({
  children,
  className = styles.TableCellBase,
  isActive,
  isResizing,
  isShort,
  ref,
  showCellBorder,
  width,
  onClick,
}) {
  const cellClassName = classNames(className, {
    [styles.resizing]: isActive && isResizing,
    [styles.short]: isShort,
    [styles.withBorder]: showCellBorder,
  })

  return (
    <div
      className={cellClassName}
      ref={ref}
      style={{ width: toCSSPixel(width) }}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default TableCellBase
